import * as React from 'react';
import styled from 'styled-components';
import getAppVariantConfig from './appVariantConfig';

const AppLogo = ({ size = 'small', className }: { size?: 'small' | 'large'; className?: string }) => {
	const { logo } = getAppVariantConfig();
	return <Img $size={size} className={className} src={logo} alt="App brand logo" />;
};

export default AppLogo;

const Img = styled.img<{ $size?: 'small' | 'large' }>`
	width: ${({ $size }) => ($size === 'small' ? '70px' : '92px')};
`;
